import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, state } = useLocation();

  useEffect(() => {
    // Don't scroll to top if we have a scroll target (for section navigation)
    if (state?.scrollTo) {
      return;
    }

    // Scroll to top on route change
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, [pathname, state]);

  return null; // This component doesn't render anything
};

export default ScrollToTop;